var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowItWorksArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 24,
    viewBox: "0 0 136 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.061 13.0607C135.646 12.4749 135.646 11.5251 135.061 10.9394L125.515 1.39341C124.929 0.807622 123.979 0.807622 123.393 1.39341C122.808 1.9792 122.808 2.92894 123.393 3.51473L131.879 12L123.393 20.4853C122.808 21.0711 122.808 22.0208 123.393 22.6066C123.979 23.1924 124.929 23.1924 125.515 22.6066L135.061 13.0607ZM-1.31134e-07 13.5L134 13.5L134 10.5L1.31134e-07 10.5L-1.31134e-07 13.5Z",
    fill: "url(#paint0_linear_330_1686)",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_330_1686",
    x1: 125.988,
    y1: 14.34,
    x2: -1.78133,
    y2: 10.7109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0398851,
    stopColor: "#31D054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F64E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksArrow);
export default __webpack_public_path__ + "static/media/howItWorks_arrow.c6220c013c147d5b8f0edf44b163152e.svg";
export { ForwardRef as ReactComponent };